import React, { useState } from 'react';

interface RequestButtonProps {
  requestBody: Record<string, any>;
  onRequestSuccess?: (responseData?: any) => void;
  onRequestError?: (error: string) => void;
  label?: string;
  disabled?: boolean;
}

const REQUEST_API_URL = 'https://pharma-amd-0-1-42.onrender.com/pharma/api/admin/pharma/request';

export const sendAdminRequest = async (requestBody: Record<string, any>) => {
  const authToken = localStorage.getItem('authToken');
  if (!authToken) {
    throw new Error('Authentication token not found. Please log in again.');
  }

  console.log('========================================');
  console.log('REQUEST API CALL:', REQUEST_API_URL);
  console.log('REQUEST METHOD:', 'POST');
  console.log('REQUEST BODY:', JSON.stringify(requestBody, null, 2));
  console.log('========================================');

  const response = await fetch(REQUEST_API_URL, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || `HTTP ${response.status}`);
  }

  try {
    return await response.json();
  } catch {
    return null;
  }
};

const RequestButton: React.FC<RequestButtonProps> = ({
  requestBody,
  onRequestSuccess,
  onRequestError,
  label = 'Send Request',
  disabled = false,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isDisabled = disabled || isSubmitting;

  const handleSendRequest = async () => {
    if (isDisabled) return;
    try {
      setIsSubmitting(true);
      const result = await sendAdminRequest(requestBody);

      if (onRequestSuccess) {
        onRequestSuccess(result);
      }
    } catch (error: any) {
      const message = error?.message || 'Failed to send request';
      if (onRequestError) {
        onRequestError(message);
      } else {
        alert(message);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <button
      onClick={handleSendRequest}
      disabled={isDisabled}
      style={{
        background: isDisabled
          ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)'
          : 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
        color: 'white',
        border: 'none',
        padding: '0.5rem 0.75rem',
        borderRadius: '6px',
        fontSize: '0.75rem',
        fontWeight: '600',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '0.375rem',
        opacity: isDisabled ? 0.7 : 1,
        boxShadow: isDisabled ? 'none' : '0 2px 6px rgba(37, 99, 235, 0.3)',
      }}
    >
      {isSubmitting ? 'Sending...' : label}
    </button>
  );
};

export default RequestButton;
